import { BoxProps } from '@mindfulchefuk/design-system/layout/Box'
import { Svg } from '@mindfulchefuk/design-system/Svg/Svg'
import React from 'react'

const Top = (props: BoxProps) => {
  return (
    <Svg
      display="block"
      viewBox="0 0 864 31"
      fill="none"
      preserveAspectRatio="none"
      {...props}
    >
      <path
        d="M864 31V7.48276L540.153 21.5557C453.113 25.3379 365.92 22.3208 279.321 12.5298L262.497 10.6276C175.334 0.772858 87.5122 -1.33606 0 4.32404V31H864Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </Svg>
  )
}

const Bottom = (props: BoxProps) => {
  return (
    <Svg
      display="block"
      viewBox="0 0 864 38"
      fill="none"
      preserveAspectRatio="none"
      {...props}
    >
      <svg viewBox="0 0 864 38" fill="none">
        <path
          d="M864 28.6996V0H0V25.516C85.7794 17.4415 172.062 16.6319 257.971 23.0952L396.959 33.5519C463.807 38.5812 530.934 38.3097 597.742 32.7401L723.317 22.271C737.796 21.064 752.341 20.9621 766.833 21.9664L864 28.6996Z"
          fill="currentColor"
          stroke="currentColor"
        />
      </svg>
    </Svg>
  )
}

export const MyAccountWave = { Top, Bottom }
